import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';

class VerificationEvidenceShow extends Component {

     getFileNameFromPath = (filePath) => {
          if (!filePath) return 'Evidence Document';
          
          // Extract filename from URL or file path
          const pathParts = filePath.split('/');
          const fileName = pathParts[pathParts.length - 1];
          
          // If it contains query parameters, extract just the filename
          if (fileName.includes('?evidence=')) {
               const evidencePart = fileName.split('?evidence=')[1];
               const decodedPath = decodeURIComponent(evidencePart);
               const decodedParts = decodedPath.split('/');
               return decodedParts[decodedParts.length - 1];
          }
          
          return fileName || 'Evidence Document';
     }

     getFileIcon = (fileName) => {
          const extension = fileName.toLowerCase().split('.').pop();
          
          switch(extension) {
               case 'pdf':
                    return '/images/icons/pdf-icon.png';
               case 'txt':
                    return '/images/icons/text-icon.png';
               case 'json':
                    return '/images/icons/json-icon.png';
               case 'jpg':
               case 'jpeg':
               case 'png':
                    return '/images/icons/image-icon.png';
               default:
                    return '/images/icons/document-icon.png';
          }
     }

     render = () => {
          const { value } = this.props;
          
          if (!value || value.length === 0) {
               return (
                    <div className="col-md-6 col-12">
                         <div className="img-wrapper">
                              <img src={"/images/icons/no-evidence-icon.png"} alt="No Evidence" style={{ display: 'inherit' }} />
                              <div className="sub-heading1">No Evidence</div>
                         </div>
                    </div>
               );
          }

          const fileName = this.getFileNameFromPath(value);
          const fileIcon = this.getFileIcon(fileName);

          return (
               <div className="col-md-6 col-12">
                    <div className="img-wrapper">
                         <a href={value} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', color: 'inherit' }}>
                              <img src={fileIcon} alt={fileName} style={{ display: 'inherit', maxWidth: '50px', maxHeight: '50px' }} />
                              <div className="sub-heading1" style={{ fontSize: '12px', marginTop: '8px', wordBreak: 'break-word' }}>
                                   {fileName}
                              </div>
                         </a>
                    </div>
               </div>
          );
     }
}

export default withTranslation('translations')(VerificationEvidenceShow);